/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import { action, observable } from 'mobx';
import TranslationUtil from '../utils/translation';

class Screens {
  @observable
  maskedScreenDescription = TranslationUtil.getMessage('ccx.panelMasked.description');

  @observable
  maskedScreenTitle = TranslationUtil.getMessage('ccx.panelMasked.title');

  @action
  setMaskedScreenDescription(maskedScreenDescription) {
      this.maskedScreenDescription = maskedScreenDescription;
  }

  @action
  setMaskedScreenTitle(maskedScreenTitle) {
      this.maskedScreenTitle = maskedScreenTitle;
  }
}

export default new Screens();
